import { Modal, CampaignStatsChart } from "components";
import { Button } from "expano-components";

const StatsModal = ({
  name,
  channel_id,
  channel_campaign_id,
  channel_campaign_group_id,
  product_id,
  product,
  handleClose,
  default_interval,
  default_columns,
}) => {
  return (
    <Modal
      handleClose={handleClose}
      header={{
        title: `Statystyki - ${name}`,
      }}
      size="full"
      footer={<Button type="cancel" onClick={handleClose} />}
    >
      <CampaignStatsChart
        channel_id={channel_id}
        channel_campaign_id={channel_campaign_id}
        channel_campaign_group_id={channel_campaign_group_id}
        product_id={product_id}
        product={product}
        default_interval={default_interval}
        default_columns={default_columns}
      />
    </Modal>
  );
};

export default StatsModal;
